<div class="app-header" color="primary">
  <div class="header-content w-100">
    <!-- Left side - Menu toggle and title -->
    <div class="header-left">
      <div class="sidebar-icon" *ngIf="!isDesktop">
        <div>
          <ion-icon *ngIf="isMenuOpen" class="custom20 desktop-menu-icon pointer" color="gray80"
            src="../../../assets/svg/sidebar-close.svg" (click)="toggleMenu(); $event.stopPropagation()"></ion-icon>
        </div>
        <ion-icon *ngIf="!isMenuOpen" class="custom26 desktop-menu-icon pointer" color="gray80"
          src="../../../assets/svg/sidebar-open.svg" (click)="toggleMenu(); $event.stopPropagation()"></ion-icon>
      </div>
      <div class="pointer d-flex align-items-center toggle-menu-icon">
        <!-- Desktop only: logo and practice name (hidden on mobile; shown in sidemenu on mobile) -->
        <img *ngIf="isDesktop && logoUrl" [src]="logoUrl" alt="TRIARQ Logo" class="logo" (error)="onLogoError($event)" />

        <div *ngIf="isDesktop && !logoUrl && tenantName" class="body1-txt-bold line-normal ion-color-gray100">{{ tenantName }}</div>
      </div>

    </div>

    <!--added by UI-team-->
    <div class="profile-mobile-view">
      <span class="custom20-medium" color="gray100">{{ currentMenuName }}</span>
    </div>

    <!-- Right side - User info and actions -->
    <div class="header-right profile-desktop-view d-flex align-items-center">
      <!-- <ion-button mat-icon-button [matMenuTriggerFor]="userMenu" class="user-menu-btn">
        <ion-icon class="custom26" color="gray80" src="../../../assets/svg/chevron-down.svg"></ion-icon>
      </ion-button> -->

      <!-- <div class="line-height-10 profileName" id="profile-popover-trigger">
        <ion-icon class="body1-txt pointer" color="gray80" src="../../../assets/svg/chevron-down.svg"></ion-icon>
      </div> -->



      <ion-avatar slot="start"
        class="mr-0 default-avatar mobile-view-avatar column ion-align-self-center ion-align-items-center ion-justify-content-center l-preserve ion-margin-bottom mb-0">
        <img src="../../../assets/svg/female-avatar.svg" alt="User Avatar" *ngIf="userGender === '1'" />
        <img src="../../../assets/svg/male-avatar.svg" alt="User Avatar" *ngIf="userGender === '0'" />
      </ion-avatar>

      <!-- <ion-text class="body1-txt-medium mx-10 profileName" color="gray80">{{ userName }}</ion-text> -->


      <div class="d-grid align-items-flex-start mx-10">
        <ion-text class="body1-txt-medium profileName" color="gray100">{{ representativeName }}</ion-text>
        <ion-text *ngIf="isPatientRepresentative && patientName" class="caption" color="gray80">
          on behalf of {{ patientName }}
        </ion-text>
      </div>

      <div class="line-height-10 profileName" id="profile-popover-trigger">
        <ion-icon class="body1-txt pointer" color="gray80" src="../../../assets/svg/chevron-down.svg"></ion-icon>
      </div>



      <!-- <div class="line-height-10 ml-10 pointer" (click)="openHelpInfoDoc()">
        <ion-icon class="custom26" color="gray80" src="../../../assets/svg/question-circle.svg"></ion-icon>
      </div> -->
      <!-- <ion-button color="gray100" fill="clear" class="small-ic-btn">
              <div class="align-items-center d-flex">
                <ion-icon color="gray80 tooltip pointer" src="../../../../../../assets/svg/chevron-down.svg"></ion-icon>
              </div>
      </ion-button> -->

      <!-- <ion-button slot="only-icon" shape="round" fill="clear"
      class=" ion-no-padding round-icon-button">
        <ion-icon class="custom26" color="gray80" src="../../../assets/svg/chevron-down.svg"></ion-icon>
      </ion-button> -->

      <ion-popover #profilePopoverDesktop trigger="profile-popover-trigger" side="bottom" dismiss-on-select="true" show-backdrop="false"
        class="order-editpopover pointer" arrow="false">
        <ng-template>

          <ion-item class="ion-no-padding logout-section body1-txt" (click)="navigateTo('/profile')">

            <ion-label color="gray80" class="body1-txt ml-15">My Profile</ion-label>
          </ion-item>
          <ion-item class="ion-no-padding logout-section body1-txt" (click)="navigateTo('/audit-log')">

            <ion-label color="gray80" class="body1-txt ml-15">My Access Log</ion-label>
          </ion-item>
          <ion-item class="ion-no-padding logout-section body1-txt" (click)="openHelpInfoDoc()">

            <ion-label color="gray80" class="body1-txt ml-15">Help & Support</ion-label>
          </ion-item>

          <ion-item class="ion-no-padding logout-section body1-txt" (click)="logout()">

            <ion-label color="gray80" class="body1-txt ml-15">Logout</ion-label>
          </ion-item>
        </ng-template>
      </ion-popover>
    </div>

    <div class="header-right profile-mobile-view d-flex">
      <!--added by UI-team-->
      <ion-avatar id="profile-popover-trigger-M" slot="start"
        class="mr-0 default-avatar mobile-view-avatar column ion-align-self-center ion-align-items-center ion-justify-content-center l-preserve ion-margin-bottom mb-0">
        <img src="../../../assets/svg/female-avatar.svg" alt="User Avatar" *ngIf="userGender === '1'" />
        <img src="../../../assets/svg/male-avatar.svg" alt="User Avatar" *ngIf="userGender === '0'" />
      </ion-avatar>

      <!-- <div class="line-height-10 ml-10 pointer" (click)="openHelpInfoDoc()">
        <ion-icon class="custom26" color="gray80" src="../../../assets/svg/question-circle.svg"></ion-icon>
      </div>  -->
      <!-- <div class="d-flex align-items-center">
        <ion-text class="body1-txt-medium mr-10 profileName" color="gray80">{{ userName }}</ion-text>
        <div class="line-height-10 profileName" id="profile-popover-trigger-M">
          <ion-icon class="body1-txt pointer" color="gray80" src="../../../assets/svg/chevron-down.svg"></ion-icon>
        </div>
      </div> -->
      <ion-popover #profilePopoverMobile trigger="profile-popover-trigger-M" side="bottom" dismiss-on-select="true" show-backdrop="false"
        class="order-editpopover pointer" arrow="false">
        <ng-template>

          <div class="ion-no-padding profile-name-mobile body1-txt p-10">
            <div class="flex-item">
              <!-- <ion-text color="black" class="body2-txt-italic">{{ userName }}</ion-text> -->
              <ion-text color="black" class="body2-txt-italic">{{ representativeName }}</ion-text>
              <ion-text *ngIf="isPatientRepresentative && patientName" color="gray100" class="body2-txt-italic">
                on behalf of {{ patientName }}
              </ion-text>
            </div>
          </div>

          <ion-item class="ion-no-padding logout-section body1-txt" (click)="navigateTo('/profile')">

            <ion-label color="gray80" class="body1-txt ml-15">My Profile</ion-label>
          </ion-item>
          <ion-item class="ion-no-padding logout-section body1-txt" (click)="navigateTo('/audit-log')">

            <ion-label color="gray80" class="body1-txt ml-15">My Access Log</ion-label>
          </ion-item>
          <ion-item class="ion-no-padding logout-section body1-txt" (click)="openHelpInfoDoc()">

            <ion-label color="gray80" class="body1-txt ml-15">Help & Support</ion-label>
          </ion-item>
          <ion-item class="ion-no-padding logout-section body1-txt" (click)="logout()">

            <ion-label color="gray80" class="body1-txt ml-15">Logout</ion-label>
          </ion-item>
        </ng-template>
      </ion-popover>
    </div>
  </div>
</div>